function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageMatchBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6488 27.8756C28.2209 25.4072 26.0206 23.6372 23.4528 22.7981C24.723 22.042 25.7098 20.8898 26.2618 19.5185C26.8137 18.1473 26.9003 16.6327 26.5082 15.2075C26.1161 13.7823 25.267 12.5252 24.0912 11.6292C22.9155 10.7333 21.4782 10.248 20 10.248C18.5218 10.248 17.0845 10.7333 15.9088 11.6292C14.7331 12.5252 13.8839 13.7823 13.4918 15.2075C13.0997 16.6327 13.1863 18.1473 13.7382 19.5185C14.2902 20.8898 15.277 22.042 16.5472 22.7981C13.9794 23.6362 11.7791 25.4062 10.3513 27.8756C10.2989 27.961 10.2642 28.056 10.2491 28.155C10.2341 28.254 10.239 28.355 10.2636 28.4521C10.2883 28.5492 10.3321 28.6404 10.3925 28.7202C10.4529 28.8001 10.5287 28.867 10.6155 28.9171C10.7022 28.9672 10.7981 28.9995 10.8975 29.0119C10.9968 29.0243 11.0977 29.0167 11.1941 28.9896C11.2905 28.9624 11.3805 28.9162 11.4587 28.8537C11.537 28.7912 11.6019 28.7136 11.6497 28.6256C13.4159 25.5731 16.5378 23.7506 20 23.7506C23.4622 23.7506 26.5841 25.5731 28.3503 28.6256C28.3981 28.7136 28.4631 28.7912 28.5413 28.8537C28.6196 28.9162 28.7095 28.9624 28.8059 28.9896C28.9023 29.0167 29.0032 29.0243 29.1026 29.0119C29.2019 28.9995 29.2978 28.9672 29.3845 28.9171C29.4713 28.867 29.5471 28.8001 29.6075 28.7202C29.6679 28.6404 29.7118 28.5492 29.7364 28.4521C29.761 28.355 29.766 28.254 29.7509 28.155C29.7358 28.056 29.7011 27.961 29.6488 27.8756ZM14.75 17.0006C14.75 15.9622 15.0579 14.9472 15.6348 14.0839C16.2117 13.2205 17.0316 12.5476 17.9909 12.1502C18.9502 11.7529 20.0058 11.6489 21.0242 11.8515C22.0426 12.054 22.9781 12.5541 23.7123 13.2883C24.4465 14.0225 24.9466 14.958 25.1491 15.9764C25.3517 16.9948 25.2477 18.0504 24.8504 19.0097C24.453 19.969 23.7801 20.7889 22.9168 21.3658C22.0534 21.9427 21.0384 22.2506 20 22.2506C18.6081 22.2491 17.2736 21.6955 16.2893 20.7113C15.3051 19.727 14.7515 18.3925 14.75 17.0006Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMatchBlue);
export default __webpack_public_path__ + "static/media/image-match-blue.9d847d09a7e6d0bf7daa5c62077c5599.svg";
export { ForwardRef as ReactComponent };